import { render, staticRenderFns } from "./IncomeSubscriptions.vue?vue&type=template&id=3a842b74"
import script from "./IncomeSubscriptions.vue?vue&type=script&lang=js"
export * from "./IncomeSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports